import { GROUND_ROW, cutPit, fillRect, freeze, makeGrid, setCell, stampPipe, type EntitySpawn, type LevelDef } from "./types";

function blockRow(
  grid: string[][],
  ty: number,
  start: number,
  pattern: string,
): void {
  for (let i = 0; i < pattern.length; i += 1) {
    const ch = pattern[i];
    if (ch && ch !== ".") setCell(grid, start + i, ty, ch);
  }
}

export function buildWorld11(): LevelDef {
  const width = 212;
  const grid = makeGrid(width);
  const entities: EntitySpawn[] = [];
  const pipes: LevelDef["pipes"] = [];

  const hill = (tx: number, size: 1 | 2 | 3): void => {
    for (let s = 0; s < size; s += 1) {
      setCell(grid, tx + s, GROUND_ROW - 1, "M");
    }
  };
  const bush = (tx: number, size: 1 | 2 | 3): void => {
    for (let s = 0; s < size; s += 1) {
      setCell(grid, tx + s, GROUND_ROW - 1, "N");
    }
  };
  const cloud = (tx: number, ty: number, size: 1 | 2 | 3): void => {
    for (let s = 0; s < size + 1; s += 1) {
      setCell(grid, tx + s, ty, "O");
    }
  };

  bush(11, 3);
  hill(16, 2);
  cloud(8, 3, 2);
  cloud(36, 2, 3);
  cloud(55, 4, 1);
  cloud(88, 3, 2);
  bush(41, 1);
  hill(48, 3);
  bush(60, 2);
  cloud(110, 2, 2);
  hill(125, 2);
  bush(140, 3);
  cloud(150, 3, 3);
  cloud(175, 2, 1);

  setCell(grid, 16, 9, "?");
  blockRow(grid, 9, 20, "#!#?#");
  setCell(grid, 22, 5, "?");

  pipes.push({ tx: 28, height: 2 });
  stampPipe(grid, 28, 2);
  pipes.push({ tx: 38, height: 3 });
  stampPipe(grid, 38, 3);
  pipes.push({
    tx: 46,
    height: 4,
    dest: { levelId: "1-1-bonus", enter: "pipe-down" },
  });
  stampPipe(grid, 46, 4);
  entities.push({ kind: "plant", tx: 46 });
  pipes.push({ tx: 57, height: 4 });
  stampPipe(grid, 57, 4);
  entities.push({ kind: "plant", tx: 57 });

  cutPit(grid, 69, 2);
  blockRow(grid, 9, 77, "###?#");
  blockRow(grid, 5, 80, "?");
  cutPit(grid, 86, 3);

  blockRow(grid, 9, 91, "#!#");
  blockRow(grid, 5, 94, "#####");
  setCell(grid, 94, 5, "?");
  setCell(grid, 97, 5, "?");

  pipes.push({ tx: 103, height: 3 });
  stampPipe(grid, 103, 3);
  entities.push({ kind: "plant", tx: 103 });

  blockRow(grid, 9, 118, "?");
  setCell(grid, 129, 9, "?");
  setCell(grid, 130, 9, "?");
  setCell(grid, 170, 9, "!");

  pipes.push({
    tx: 163,
    height: 2,
    dest: { levelId: "1-1", tx: 164, ty: GROUND_ROW, enter: "pipe-up" },
  });
  stampPipe(grid, 163, 2);

  pipes.push({ tx: 179, height: 3 });
  stampPipe(grid, 179, 3);

  for (let step = 0; step < 4; step += 1) {
    fillRect(grid, 187 + step, GROUND_ROW - 1 - step, 1, step + 1, "S");
  }
  for (let step = 0; step < 4; step += 1) {
    fillRect(grid, 192 + step, GROUND_ROW - 4 + step, 1, 4 - step, "S");
  }
  fillRect(grid, 198, GROUND_ROW - 8, 1, 8, "F");
  setCell(grid, 198, GROUND_ROW - 9, "G");
  fillRect(grid, 203, GROUND_ROW - 5, 5, 5, "C");
  setCell(grid, 205, GROUND_ROW - 2, "D");

  const walkers = [22, 40, 51, 54, 82, 84, 97, 99, 114, 116, 128, 174, 176];
  for (const tx of walkers) {
    entities.push({ kind: "walker", tx, ty: GROUND_ROW });
  }
  entities.push({ kind: "troopa", tx: 107, ty: GROUND_ROW, color: "green" });

  return {
    id: "1-1",
    worldLabel: "1-1",
    theme: "overworld",
    time: 400,
    tiles: freeze(grid),
    entities,
    pipes,
    playerSpawn: { tx: 3, ty: GROUND_ROW },
    flagX: 198,
    castleX: 203,
    next: "1-2",
  };
}

export function buildBonus11(): LevelDef {
  const width = 42;
  const grid = makeGrid(width, false);
  fillRect(grid, 0, 0, width, 15, "S");
  fillRect(grid, 2, 2, width - 4, 11, ".");
  fillRect(grid, 2, GROUND_ROW, width - 4, 2, "=");

  for (const y of [4, 6, 8, 10]) {
    for (let x = 4; x <= 32; x += 1) {
      setCell(grid, x, y, "W");
    }
  }

  stampPipe(grid, 36, 2);
  const pipes: LevelDef["pipes"] = [
    {
      tx: 36,
      height: 2,
      dest: { levelId: "1-1", tx: 164, ty: GROUND_ROW, enter: "pipe-up" },
    },
  ];

  return {
    id: "1-1-bonus",
    worldLabel: "1-1",
    theme: "underground",
    time: 400,
    tiles: freeze(grid),
    entities: [],
    pipes,
    playerSpawn: { tx: 4, ty: GROUND_ROW },
    next: "1-1",
    returnTo: { levelId: "1-1", tx: 164, ty: GROUND_ROW, enter: "pipe-up" },
  };
}
